export default "__VITE_ASSET__576cc06d__"